export const REQUESTER_REDIRECT_SOURCE_SEARCH_PARAM = 'source';

// Synthetic ticketFieldId for the locked-in Request Status column on the
// requester portal. Mirrors the server-side `PRIMARY_STATUS_MARKER` in
// `validator/src/ticketing/requester-portal/types.ts`. Cells with this id
// resolve to whichever ticket field value carries `isPrimaryStatus === true`
// — i.e. each row's own layout's primary status, not a specific field.
export const PRIMARY_STATUS_MARKER = 'primary_status';

export enum RequesterRedirectSource {
  SLACK = 'slack',
  AGENT_REDIRECT = 'agent-redirect',
  PARTICIPANT_REDIRECT = 'participant-redirect',
  SHARE_LINK = 'share-link',
  PLATFORM_REDIRECT = 'platform-redirect',
  PLATFORM = 'platform',
  REQUESTER_PORTAL = 'requester-portal',
}
